<template>
  <div>
    <template v-for="(error,index) of errors.errormessages">
      <v-snackbar :key="index"
                  v-model="displayerrors"
                  :timeout="errors.timeout !== null && errors.timeout !== undefined ? errors.timeout : 4000"
                  :color="errors.isInfo ? 'primary' : 'error'"
                  bottom
                  multi-line>
        <v-row align="center"
               no-gutters
               :class="'snackbar-message flex-nowrap' + isInfo ? ' py-3' : ''">
          <v-col cols="auto"><v-icon color="white"
                       size="32"
                       class="mr-3">{{ errors.isInfo ? 'info' : 'warning' }}
            </v-icon>
          </v-col>
          <v-col v-html="error"></v-col>
          
          <v-col v-if="errors.closebutton"
                  cols="auto" 
                  class="closebutton">
            <v-icon color="white"
                    @click="displayerrors=false">close
            </v-icon>
          </v-col>
        </v-row>
      </v-snackbar>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    errors: {
      type: Object,
      required: true
    },
    mutation: {
      type: String,
      default: null
    }
  },
  computed: {
    displayerrors: {
      get() {
        return this.errors.displayerrors;
      },
      set() {
        this.mutation ? this.$store.commit(`${this.mutation}`) : this.errors.displayerrors = false;
      }
    }
  }
};
</script>
<style>
.snackbar-message {
  min-width: 100%;
}
.closebutton {
  align-self:flex-start;
  text-align: right;
}
</style>


